module.exports = __webpack_public_path__ + "media/images/icons/icon-explore-flag-15997ea166fcbbe100a94552fabfaaf2.svg";